import { Directive, ElementRef, AfterViewChecked, Input } from '@angular/core';
import { uuid } from 'helpers';

/**
 * In the ongoing war against developers, most browsers
 * have decided that when we use "autocomplete"="off"
 * that we really don't mean it...
 * This directive will take any autocomplete="off" and
 * set autocomplete="" to some completely random uuid.
 * This will prevent the browser from trying to autocomplete the field.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[autocomplete]'
})
export class AutocompleteOffDirective  {
  @Input() autocomplete: string;
  constructor(private el: ElementRef) {
  }


  disableAutocomplete() {
    try {
      this.el?.nativeElement?.setAttribute('autocomplete', uuid());
    } catch (e) { console.error(e); }
  }

}
